import { FC, SVGProps } from 'react';

export const ThreeDotsMenuVerticalIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.3334 23.1177C16.4054 23.1177 17.2745 23.9868 17.2745 25.0589C17.2745 26.131 16.4054 27.0001 15.3334 27.0001C14.2613 27.0001 13.3922 26.131 13.3922 25.0589C13.3922 23.9868 14.2613 23.1177 15.3334 23.1177ZM15.3334 14.0588C16.4054 14.0588 17.2745 14.9279 17.2745 16C17.2745 17.0721 16.4054 17.9412 15.3334 17.9412C14.2613 17.9412 13.3922 17.0721 13.3922 16C13.3922 14.9279 14.2613 14.0588 15.3334 14.0588ZM17.2745 6.94118C17.2745 5.8691 16.4054 5 15.3334 5C14.2613 5 13.3922 5.8691 13.3922 6.94118C13.3922 8.01326 14.2613 8.88236 15.3334 8.88236C16.4054 8.88236 17.2745 8.01326 17.2745 6.94118Z"
			fill="currentColor"
		/>
	</svg>
);
